export default __webpack_public_path__ + "static/inTouch-animated-d8921fbf523601e468c71728c4d42e7d.gif";